import { useState } from 'react';

import { observer } from 'mobx-react';

import strokeCheckmark from '../../../assets/daily-bonus/strokeCheckmark.svg';
import { useStores } from '../../../stores/useStores';

import classes from './BonusProgress.module.scss';
import { MonthlyBonusTooltip } from './MonthlyBonusTooltip';
import ProgressBonusImage from './ProgressBonusImage';

const BonusProgress = observer(() => {
  const { rewardsStore } = useStores();
  const [monthlyTooltip, setMonthlyTooltip] = useState({
    day: 0,
    sc: 0,
    gc: 0,
  });

  const currentDay = rewardsStore.dailyBonus?.monthlyBonusDay || 0;

  const width = ((currentDay || 0) / 30) * 100;

  return (
    <div className={'animation-popup ' + classes.monthlyBonusWrapper}>
      <div className={classes.monthlyBonus}>
        <div className={classes.progress} style={{ width: `${width + (currentDay === 29 ? -3 : 0)}%` }}>
          <div className={classes.check}>
            <img className={classes.strokeCheckmark} src={strokeCheckmark} />
            <span className={classes.currentDay}>{currentDay}</span>
          </div>
        </div>
        <div className={classes.present}>
          <div className={classes.item} />
          {rewardsStore.monthlyBonusesList?.map((item) => (
            <div
              key={item.day}
              className={'animation-popup ' + classes.item}
              onClick={() => {
                setMonthlyTooltip((popup) => ({
                  day: item.day === popup.day ? 0 : item.day,
                  sc: item.sc_amount,
                  gc: item.gc_amount,
                }));
              }}
            >
              <ProgressBonusImage day={item.day} />
              <div className={classes.itemCircle}>
                {currentDay >= item.day && <img className={classes.strokeCheckmark} src={strokeCheckmark} />}
                <span>{item?.day}</span>
              </div>
              {monthlyTooltip.day === item.day && (
                <MonthlyBonusTooltip
                  day={monthlyTooltip.day}
                  gc={monthlyTooltip.gc}
                  sc={monthlyTooltip.sc}
                  onClose={() => {
                    setMonthlyTooltip((prev) => ({ ...prev, day: 0 }));
                  }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});

export default BonusProgress;
